module.exports = __webpack_public_path__ + "static/media/pd-1.107472a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/pd-1.jpg
// module id = 125
// module chunks = 0